export default __webpack_public_path__ + "static/media/map.fc1ee738.png";